import update from 'immutability-helper';
import selectableSeatsApi from '../lib/api/selectableSeats';

// ------------------------------------
// Constants
// ------------------------------------

export const RECEIVE_SELECTABLE_SEATS = 'SELECTABLE_SEATS/LOAD_SELECTABLE_SEATS_SUCCESS';

// ------------------------------------
// Actions
// ------------------------------------

export function receiveSelectableSeats(selectableSeats) {
	return {
		type: RECEIVE_SELECTABLE_SEATS,
		selectableSeats,
	};
}

export function identifySelectableSeats(selectedSeats) {
	return async (dispatch, getState) => {
		const selectableSeats = await selectableSeatsApi.identifySelectableSeats(
			getState().merchant.merchantId,
			getState().merchant.themeName,
			getState().event.selected,
			selectedSeats);
		dispatch(receiveSelectableSeats(selectableSeats));
	};
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[RECEIVE_SELECTABLE_SEATS]: (state, action) => update(state,
		{ $set: action.selectableSeats },
	),
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = [];

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
